import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

declare const _: any;

@Component({
    selector: 'high-risk-devices',
    templateUrl: './high-risk-devices.component.html',
    styleUrls: ['./high-risk-devices.component.css']
})
export class HighRiskDevicesComponent implements OnInit {

    _: any;
    @Input() data: any;

    constructor() {
        this._ = _;
        this.data = [];
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/high-risk-devices/high-risk-devices.component.ts